// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g3NDNDpPCWY47I73iPNK{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:628px;margin:0 auto;display:flex}.g3NDNDpPCWY47I73iPNK .KpMbK9ZJVUvLHVNbg5Js{flex-direction:row;justify-content:center;gap:8px;display:flex}.g3NDNDpPCWY47I73iPNK .uxmEi9kF1ockJpWI60_9{text-align:center;flex-direction:column;display:flex}.g3NDNDpPCWY47I73iPNK .OmKvNFDKjKwTitj3uNJJ{border-radius:16px;align-items:flex-end;margin-bottom:40px;display:flex;overflow:hidden}.g3NDNDpPCWY47I73iPNK .OmKvNFDKjKwTitj3uNJJ img{width:100%;height:auto;display:block}.I_TkLXslApkZB98a7f5I{min-width:109px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `g3NDNDpPCWY47I73iPNK`,
	"actions": `KpMbK9ZJVUvLHVNbg5Js`,
	"title": `uxmEi9kF1ockJpWI60_9`,
	"titlePreview": `OmKvNFDKjKwTitj3uNJJ`,
	"actionButton": `I_TkLXslApkZB98a7f5I`
};
export default ___CSS_LOADER_EXPORT___;
